module.exports = __webpack_public_path__ + "static/media/expert2.0b90aa12.png";